import {
  ErrorModalBackground,
  ErrorModalContainer,
  ErrorModalCloseIcon,
  ErrorModalTextContainer,
  ErrorModalHeader,
  ErrorModalErrorText,
  ErrorModalButtonContainer,
  ErrorModalButtonText,
  ErrorModalIconWrapper,
  ErrorModalIconOutline,
  ErrorModalIcon,
} from "./ErrorModal.styles";
import {useAppSelector} from "store/hooks";
import {useDispatch} from "react-redux";
import {updateShowErrorPopup} from "store/ui/errorPopupScreen/errorPopupScreen.slice";

function ErrorModal() {
  const dispatch = useDispatch();
  const errorMessage = useAppSelector(state => state.error.errorMessage);

  return (
    <>
    <ErrorModalBackground onClick={() => dispatch(updateShowErrorPopup(false))}/>

    <ErrorModalContainer>
      <ErrorModalCloseIcon className="fa-solid fa-xmark" onClick={() => dispatch(updateShowErrorPopup(false))}/>
      <ErrorModalTextContainer>
        <ErrorModalIconWrapper>
          <ErrorModalIconOutline>
            <ErrorModalIcon className="fa-solid fa-exclamation"/>
          </ErrorModalIconOutline>
        </ErrorModalIconWrapper>

        <ErrorModalHeader> Sorry something went wrong </ErrorModalHeader>
        <ErrorModalErrorText> {errorMessage} </ErrorModalErrorText>
        <ErrorModalButtonContainer onClick={() => dispatch(updateShowErrorPopup(false))}>
          <ErrorModalButtonText> Back </ErrorModalButtonText>
        </ErrorModalButtonContainer>
      </ErrorModalTextContainer>
    </ErrorModalContainer>
    </>
  )
}

export default ErrorModal;
  